module.exports = __webpack_public_path__ + "media/images/icons/character-development_01-c647d14d7e218728b8cbdda6645c60f4.svg";